"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const i18n_1 = tslib_1.__importDefault(require("./i18n"));
exports.TranslationProvider = (0, react_1.memo)(function TranslationProvider({ children, language, translationContent, }) {
    (0, react_1.useEffect)(() => {
        i18n_1.default.addResourceBundle(language, 'translation', translationContent);
        i18n_1.default.changeLanguage(language);
    }, [language, translationContent]);
    return (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, { i18n: i18n_1.default, children: children });
});
//# sourceMappingURL=TranslationProvider.js.map